const LIGHT_LOGO_URL = "https://res.cloudinary.com/dfg8nrgvf/image/upload/q_auto/f_auto/v1780696106/Remove_Background_wepspn.png";
const PRIMARY_COLOR = "#0047FF";

/**
 * High-Compatibility Email Wrapper
 * Uses explicit inline styles and tables for Spark, Outlook, and Gmail.
 */
export const getEmailWrapper = (content) => `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <title>BookOTG Notification</title>
</head>
<body style="margin: 0; padding: 0; background-color: #F8FAFC; font-family: 'Segoe UI', Helvetica, Arial, sans-serif;">
  <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #F8FAFC;">
    <tr>
      <td align="center" style="padding: 40px 10px;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px; background-color: #ffffff; border-radius: 24px; overflow: hidden; border: 1px solid #E2E8F0; box-shadow: 0 10px 30px rgba(0,0,0,0.05);">
          <!-- Header -->
          <tr>
            <td align="center" style="padding: 40px 40px 20px 40px;">
              <img src="${LIGHT_LOGO_URL}" alt="BookOTG" width="160" style="display: block; border: 0;" />
            </td>
          </tr>
          <!-- Body Content -->
          <tr>
            <td style="padding: 20px 40px 40px 40px; background-color: #ffffff;">
              ${content}
            </td>
          </tr>
          <!-- Footer -->
          <tr>
            <td align="center" style="padding: 30px 40px; background-color: #F1F5F9; border-top: 1px solid #E2E8F0;">
              <p style="margin: 0; font-size: 12px; font-weight: 800; color: #94A3B8; text-transform: uppercase; letter-spacing: 2px;">
                Book On The Go • Sri Lanka
              </p>
              <p style="margin: 8px 0 0 0; font-size: 10px; color: #CBD5E1; font-weight: 500;">
                Managed by Fesy Marketing Pvt Ltd
              </p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
`;

export const templates = {
  welcomeEmail: (name, role) => getEmailWrapper(`
    <h1 style="margin: 0 0 20px 0; font-size: 28px; font-weight: 900; color: #0E1B2B; line-height: 1.2;">Ayubowan, ${name}!</h1>
    <p style="margin: 0 0 30px 0; font-size: 16px; line-height: 1.6; color: #475569;">
      ${role === 'barber' ? "Welcome to Sri Lanka's elite grooming network. Your professional profile is now live! Get ready to receive bookings and grow your business on your own terms." : "Welcome to the future of grooming. Elite barbers are now just a tap away. Book professional grooming services to your doorstep anytime, anywhere."}
    </p>
    <table border="0" cellpadding="0" cellspacing="0" width="100%">
      <tr>
        <td align="center">
          <a href="https://bookotg.com/login" style="background-color: ${PRIMARY_COLOR}; color: #ffffff; padding: 18px 40px; border-radius: 14px; text-decoration: none; font-weight: 800; font-size: 16px; display: inline-block; box-shadow: 0 4px 15px rgba(0,71,255,0.3);">Go to Dashboard</a>
        </td>
      </tr>
    </table>
  `),

  bookingReceived: (details) => getEmailWrapper(`
    <h1 style="margin: 0 0 15px 0; font-size: 26px; font-weight: 900; color: #0E1B2B;">New Booking Request</h1>
    <p style="margin: 0 0 25px 0; font-size: 16px; color: #475569;">You have a new appointment request for <strong>${details.serviceName}</strong>.</p>
    
    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #F8FAFC; border: 1px solid #E2E8F0; border-radius: 16px; margin-bottom: 30px;">
      <tr>
        <td style="padding: 25px;">
          <p style="margin: 0 0 5px 0; font-size: 11px; font-weight: 800; color: #94A3B8; text-transform: uppercase;">Client Name</p>
          <p style="margin: 0 0 15px 0; font-size: 16px; font-weight: 700; color: #0E1B2B;">${details.customerName}</p>
          
          <p style="margin: 0 0 5px 0; font-size: 11px; font-weight: 800; color: #94A3B8; text-transform: uppercase;">Schedule</p>
          <p style="margin: 0 0 15px 0; font-size: 16px; font-weight: 700; color: #0E1B2B;">${details.date} at ${details.time}</p>
          
          <p style="margin: 0 0 5px 0; font-size: 11px; font-weight: 800; color: #94A3B8; text-transform: uppercase;">Location</p>
          <p style="margin: 0; font-size: 15px; font-weight: 600; color: #64748B; line-height: 1.4;">${details.address}</p>
        </td>
      </tr>
    </table>

    <table border="0" cellpadding="0" cellspacing="0" width="100%">
      <tr>
        <td align="center">
          <a href="${details.manageLink}" style="background-color: ${PRIMARY_COLOR}; color: #ffffff; padding: 18px 40px; border-radius: 14px; text-decoration: none; font-weight: 800; font-size: 16px; display: inline-block;">View Request</a>
        </td>
      </tr>
    </table>
  `),

  bookingConfirmed: (details) => getEmailWrapper(`
    <h1 style="margin: 0 0 15px 0; font-size: 26px; font-weight: 900; color: #0E1B2B;">Booking Confirmed!</h1>
    <p style="margin: 0 0 25px 0; font-size: 16px; color: #475569;">Great news! Your appointment has been approved. Your professional barber will arrive at the scheduled time.</p>
    
    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #F8FAFC; border: 1px solid #E2E8F0; border-radius: 16px; margin-bottom: 30px;">
      <tr>
        <td style="padding: 25px;">
          <p style="margin: 0 0 5px 0; font-size: 11px; font-weight: 800; color: #94A3B8; text-transform: uppercase;">Barber</p>
          <p style="margin: 0 0 15px 0; font-size: 16px; font-weight: 700; color: #0E1B2B;">${details.barberName}</p>
          
          <p style="margin: 0 0 5px 0; font-size: 11px; font-weight: 800; color: #94A3B8; text-transform: uppercase;">Service</p>
          <p style="margin: 0 0 15px 0; font-size: 16px; font-weight: 700; color: #0E1B2B;">${details.serviceName}</p>
          
          <p style="margin: 0 0 5px 0; font-size: 11px; font-weight: 800; color: #94A3B8; text-transform: uppercase;">Schedule</p>
          <p style="margin: 0; font-size: 16px; font-weight: 700; color: #0E1B2B;">${details.date} at ${details.time}</p>
        </td>
      </tr>
    </table>

    <table border="0" cellpadding="0" cellspacing="0" width="100%">
      <tr>
        <td align="center">
          <a href="${details.manageLink}" style="background-color: ${PRIMARY_COLOR}; color: #ffffff; padding: 18px 40px; border-radius: 14px; text-decoration: none; font-weight: 800; font-size: 16px; display: inline-block;">Manage Booking</a>
        </td>
      </tr>
    </table>
  `),

  bookingCancelled: (details) => getEmailWrapper(`
    <h1 style="margin: 0 0 15px 0; font-size: 26px; font-weight: 900; color: #EF4444;">Booking Cancelled</h1>
    <p style="margin: 0 0 25px 0; font-size: 16px; color: #475569;">The appointment for <strong>${details.serviceName}</strong> on <strong>${details.date}</strong> has been cancelled.</p>
    
    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #FFF1F2; border: 1px solid #FECDD3; border-radius: 16px; margin-bottom: 30px;">
      <tr>
        <td style="padding: 25px;">
          <p style="margin: 0 0 5px 0; font-size: 11px; font-weight: 800; color: #E11D48; text-transform: uppercase;">Cancellation Reason</p>
          <p style="margin: 0; font-size: 16px; font-weight: 700; color: #9F1239;">${details.reason || 'Not specified'}</p>
        </td>
      </tr>
    </table>

    <table border="0" cellpadding="0" cellspacing="0" width="100%">
      <tr>
        <td align="center">
          <a href="${details.manageLink}" style="background-color: #0E1B2B; color: #ffffff; padding: 18px 40px; border-radius: 14px; text-decoration: none; font-weight: 800; font-size: 16px; display: inline-block;">View Dashboard</a>
        </td>
      </tr>
    </table>
  `),

  bookingCompleted: (details) => getEmailWrapper(`
    <h1 style="margin: 0 0 15px 0; font-size: 26px; font-weight: 900; color: #0E1B2B;">Service Completed</h1>
    <p style="margin: 0 0 25px 0; font-size: 16px; color: #475569;">Thank you for choosing BookOTG! We hope you enjoyed your grooming session with <strong>${details.barberName}</strong>.</p>
    
    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #F8FAFC; border: 1px solid #E2E8F0; border-radius: 16px; margin-bottom: 30px;">
      <tr>
        <td style="padding: 25px;">
          <p style="margin: 0 0 5px 0; font-size: 11px; font-weight: 800; color: #94A3B8; text-transform: uppercase;">Completed Service</p>
          <p style="margin: 0 0 15px 0; font-size: 16px; font-weight: 700; color: #0E1B2B;">${details.serviceName}</p>
          <p style="margin: 0 0 5px 0; font-size: 11px; font-weight: 800; color: #94A3B8; text-transform: uppercase;">Date</p>
          <p style="margin: 0; font-size: 16px; font-weight: 700; color: #0E1B2B;">${details.date}</p>
        </td>
      </tr>
    </table>

    <table border="0" cellpadding="0" cellspacing="0" width="100%">
      <tr>
        <td align="center">
          <a href="${details.manageLink}" style="background-color: ${PRIMARY_COLOR}; color: #ffffff; padding: 18px 40px; border-radius: 14px; text-decoration: none; font-weight: 800; font-size: 16px; display: inline-block;">Leave a Review</a>
        </td>
      </tr>
    </table>
  `),

  promotionalEmail: (subject, content) => getEmailWrapper(`
    <h1 style="margin: 0 0 20px 0; font-size: 26px; font-weight: 900; color: #0E1B2B;">${subject}</h1>
    <div style="font-size: 16px; line-height: 1.6; color: #475569;">
      ${content}
    </div>
  `),

  supabaseConfirm: () => getEmailWrapper(`
    <h1 style="margin: 0 0 20px 0; font-size: 26px; font-weight: 900; color: #0E1B2B;">Verify your account</h1>
    <p style="margin: 0 0 30px 0; font-size: 16px; line-height: 1.6; color: #475569;">Welcome to BookOTG! Please click the button below to confirm your email address and activate your account.</p>
    <table border="0" cellpadding="0" cellspacing="0" width="100%">
      <tr>
        <td align="center">
          <a href="#" style="background-color: ${PRIMARY_COLOR}; color: #ffffff; padding: 18px 40px; border-radius: 14px; text-decoration: none; font-weight: 800; font-size: 16px; display: inline-block;">Confirm Email Address</a>
        </td>
      </tr>
    </table>
  `),

  passwordReset: () => getEmailWrapper(`
    <h1 style="margin: 0 0 20px 0; font-size: 26px; font-weight: 900; color: #0E1B2B;">Reset your password</h1>
    <p style="margin: 0 0 30px 0; font-size: 16px; line-height: 1.6; color: #475569;">We received a request to reset your password. Click the button below to choose a new one.</p>
    <table border="0" cellpadding="0" cellspacing="0" width="100%">
      <tr>
        <td align="center">
          <a href="#" style="background-color: ${PRIMARY_COLOR}; color: #ffffff; padding: 18px 40px; border-radius: 14px; text-decoration: none; font-weight: 800; font-size: 16px; display: inline-block;">Reset Password</a>
        </td>
      </tr>
    </table>
    <p style="margin-top: 30px; font-size: 14px; color: #94A3B8; text-align: center;">If you did not request this, please ignore this email.</p>
  `)
};